export enum ReferralName {
  ReferredBy = 'referred_by',
}
